import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-edit-issuer',
  templateUrl: './edit-issuer.component.html',
  styleUrls: ['./edit-issuer.component.css']
})
export class EditIssuerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-issuers/edit-issuer/edit-issuer.component.ts